import { useMemo } from "react";

import { BulkEntityActionItem } from "components/BulkActions/types";
import useCanReplanRun from "shared/Run/access/useCanReplanRun";
import { Module, Stack } from "types/generated";

import { EntityChangeWithId } from "../types";
import { ChangesBulkActions } from "./types";

const useChangesBulkActions = (
  stack: Stack | Module
): Array<BulkEntityActionItem<ChangesBulkActions, EntityChangeWithId, undefined>> => {
  const canReplan = useCanReplanRun()(stack);

  return useMemo<Array<BulkEntityActionItem<ChangesBulkActions, EntityChangeWithId, undefined>>>(
    () => [
      {
        key: ChangesBulkActions.Replan,
        title: "Replan",
        resultTitle: "Replan changes results",
        condition: () => canReplan,
        mutation: () =>
          Promise.resolve(/* This mutation is handled externally in the place it's used, a single action for all bulk actions. Types are strict here so using a "mock" value */),
      },
    ],
    [canReplan]
  );
};

export default useChangesBulkActions;
